<template>
  <base-layout redirectTo="home">
    <v-container class="cliente-cadastrado" fluid>
      <v-row no-gutters>
        <v-col>
          <p class="cliente-cadastrado-title" :style="{ color: GET_ASSETS.colors.form.buttonBackground }">{{ getTitle }}</p>
          <p class="cliente-cadastrado-subtitle">{{ getSubmessage }}</p>
        </v-col>
      </v-row>
      <div v-if="showInputs">
        <v-row no-gutters>
          <v-text-field v-model="cpfCnpj" v-mask="documentMask" outlined hide-details :label="label" class="mb-5" disabled />
        </v-row>
        <v-row no-gutters>
          <v-text-field
            v-model="password"
            outlined
            label="Senha"
            class="mb-5"
            :error-messages="errorPassword"
            :type="showPassword ? 'text' : 'password'"
            :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
            @input="errorPassword = ''"
            @click:append="showPassword = !showPassword"
          />
        </v-row>
        <v-row no-gutters>
          <v-btn
            width="100%"
            class="button-height mb-3"
            :color="GET_ASSETS.colors.form.buttonBackground"
            :style="{ color: GET_ASSETS.colors.form.buttonFont }"
            :loading="btnLoading"
            @click="login"
            >Entrar</v-btn
          >
        </v-row>
        <v-row no-gutters>
          <span class="link" @click="createNewPassword">Criar nova senha</span>
        </v-row>
        <v-snackbar v-model="snackbarLogin" left>
          Ocorreu um erro. Tente novamente mais tarde
          <template v-slot:action="{ attrs }">
            <v-btn color="white" text v-bind="attrs" @click="snackbarLogin = false">
              fechar
            </v-btn>
          </template>
        </v-snackbar>
      </div>

      <div v-else class="grid-buttons">
        <v-btn
          class="button-height first"
          :color="GET_ASSETS.colors.form.buttonBackground"
          :style="{ color: GET_ASSETS.colors.form.buttonFont }"
          @click="goBack"
          >Finalizar</v-btn
        >
        <v-btn v-if="showLoginButton" class="button-height second" outlined :color="outlinedButtonColor" @click="showInputs = true">Acessar meu cadastro</v-btn>

        <v-menu v-if="!isActivatedUser" bottom offset-y transition="scale-transition">
          <template v-slot:activator="{ on }">
            <v-btn v-if="timer > 0" class="button-height third" :color="GET_ASSETS.colors.form.buttonBackground" disabled text v-on="on">
              Reenviar validação em <strong class="pl-1">{{ secondsText }}</strong>
            </v-btn>
            <v-btn v-else text class="button-height third" :color="GET_ASSETS.colors.form.buttonBackground" :loading="btnLoading" v-on="on">
              Reenviar validação
            </v-btn>
          </template>
          <v-list>
            <v-list-item class="cursor-pointer" @click="resendBy('SMS')">
              <v-list-item-title>
                <span class="cinza-d10-text">Reenviar por SMS</span>
              </v-list-item-title>
            </v-list-item>
            <v-list-item class="cursor-pointer" @click="resendBy('EMAIL')">
              <v-list-item-title>
                <span class="cinza-d10-text">Reenviar por E-mail</span>
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </div>
    </v-container>

    <snackbar v-model="snackbarOpen" :message="snackbarData.message" :snackbar-color="snackbarData.snackbarColor" />
  </base-layout>
</template>

<script>
import { documentMaskMixin } from '@/mixins/document-mask'
import { getHSP } from '@/helpers/colors'
import { argentinianDocumentValidator, uruguayanDocumentValidator } from '@/helpers/foreign-docs-validator.js'
import { mapGetters, mapActions } from 'vuex'
import Snackbar from '@/components/Snackbar.vue'
export default {
  components: {
    BaseLayout: () => import('@/components/layout/BaseLayout.vue'),
    Snackbar
  },
  mixins: [documentMaskMixin],
  data: () => ({
    cpfCnpj: null,
    password: null,
    label: 'Documento',
    btnLoading: false,
    errorPassword: '',
    snackbarLogin: false,
    showPassword: false,
    showInputs: false,
    timer: 0,
    interval: null,
    snackbarOpen: false,
    snackbarData: {}
  }),
  computed: {
    ...mapGetters([
      'GET_ASSETS',
      'HIDDEN_EMAIL',
      'HIDDEN_PHONE',
      'SMS_CHANNEL',
      'LOGIN_MENU',
      'DELETE_REQUEST',
      'ALLOWED_MODULES',
      'IS_CONFIRMED',
      'USER_INFO'
    ]),
    isConsumerActivationModule() {
      return this.ALLOWED_MODULES.consumer_activation_after_sign_up
    },
    isActivatedUser() {
      if (!this.isConsumerActivationModule) return true
      return this.IS_CONFIRMED
    },
    getDocNo() {
      if (this.$route.query.natural || this.$route.query.legal || this.$route.query.cpfCnpj) {
        return this.$route.query.natural || this.$route.query.legal || this.$route.query.cpfCnpj
      }
      return this.USER_INFO.document_no
    },
    unmaskedDocument() {
      return this.cpfCnpj.replace(/\.|-|\//g, '')
    },
    hasEmail() {
      return this.HIDDEN_EMAIL
    },
    hasSms() {
      return this.HIDDEN_PHONE && this.SMS_CHANNEL
    },
    showLoginButton() {
      return this.LOGIN_MENU && !this.DELETE_REQUEST
    },
    getTitle() {
      if (!this.isActivatedUser) return 'Sua validação de cadastro está pendente!'
      return this.DELETE_REQUEST ? 'Sua solicitação ainda está em análise' : 'Você já faz parte do clube!'
    },
    getSubmessage() {
      if (!this.isActivatedUser) return 'Acesse seu cadastro para alterar os dados de envio.'
      if (this.DELETE_REQUEST)
        return 'Você solicitou a deleção de seus dados pelo site de cadastramento, ainda estamos analisando seu pedido. Assim que tudo estiver certo vamos te avisar pelo e-mail inserido para contato.'
      if (!this.showLoginButton)
        return 'Você já está cadastrado no nosso clube fidelidade, agora é só se identificar no caixa com o seu CPF ou CNPJ para garantir acesso aos nossos descontos. '
      return this.showInputs
        ? 'Para conferir ou atualizar seu cadastro informe ou crie uma nova senha de acesso abaixo'
        : 'Para conferir ou atualizar seu cadastro acesse o portal clicando no botão abaixo:'
    },
    isIdle() {
      return this.$store.state.idleVue.isIdle
    },
    outlinedButtonColor() {
      return getHSP(this.GET_ASSETS.colors.form.buttonBackground) < getHSP(this.GET_ASSETS.colors.form.buttonFont)
        ? this.GET_ASSETS.colors.form.buttonBackground
        : this.GET_ASSETS.colors.form.buttonFont
    },
    secondsText() {
      return this.timer > 1 ? this.timer + ' segundos' : this.timer + ' segundo'
    }
  },
  watch: {
    isIdle() {
      if (this.isIdle) this.goBack()
    }
  },
  created() {
    const query = Object.entries(this.$route.query)
    if (query.length) {
      this.cpfCnpj = query[0][1]
    }
    const fromRecover = this.$route.params.fromRecover
    if (fromRecover) this.showInputs = true
  },
  beforeDestroy() {
    this.clearInterval()
  },
  methods: {
    ...mapActions(['resendSignUpValidationByConsumer']),
    async resendBy(type) {
      const document_no = this.getDocNo
      const variables = {
        input: {
          document_no,
          type
        }
      }
      try {
        const { resendSignUpConfirmationByConsumer } = await this.resendSignUpValidationByConsumer(variables)
        if (!resendSignUpConfirmationByConsumer) throw new Error()

        this.handleTimer()
        this.snackbarData = {
          message: 'Validação reenviada com sucesso.',
          snackbarColor: 'success'
        }
        this.snackbarOpen = true
      } catch (error) {
        console.log(error)
        this.snackbarData = {
          message: 'Houve um erro ao reenviar a validação.',
          snackbarColor: 'error'
        }
        this.snackbarOpen = true
      }
    },
    createNewPassword() {
      if (this.hasEmail) {
        this.redirect('recuperar-senha', this.unmaskedDocument)
        return
      }
      if (this.hasSms) {
        this.redirect('recuperar-senha-sms', this.unmaskedDocument)
        return
      }
      this.$router.push({ path: '/contato' })
    },
    clearInterval() {
      clearInterval(this.interval)
      this.interval = null
    },

    handleTimer() {
      this.timer = 60
      this.interval = setInterval(() => {
        this.timer--
        if (this.timer === 0) this.clearInterval()
      }, 1000)
    },
    redirect(route, value) {
      let key = ''
      let doc = ''
      if (this.selectedCountry === 'ARGENTINA') {
        doc = argentinianDocumentValidator(value)
        key = doc === 'CUIL' ? 'natural' : 'legal'
      } else if (this.selectedCountry === 'URUGUAY') {
        doc = uruguayanDocumentValidator(value)
        key = doc === 'CI' ? 'natural' : 'legal'
      } else {
        key = value.length === 11 ? 'natural' : 'legal'
      }
      this.$router.push({
        path: route,
        query: { [key]: value }
      })
    },
    login() {
      if (!this.password) {
        this.errorPassword = 'Esse campo é obrigatório'
        return
      }
      this.btnLoading = true
      this.$store
        .dispatch('login', {
          document_no: this.unmaskedDocument,
          password: this.password
        })
        .then(() => {
          this.redirect('cadastro', this.unmaskedDocument)
        })
        .catch(err => {
          if (err.response && err.response.errors[0] && err.response.errors[0].message === 'invalid.password') {
            this.errorPassword = 'Senha incorreta'
            return
          }
          this.snackbarLogin = true
        })
        .finally(() => {
          this.btnLoading = false
        })
    },
    goBack() {
      this.$router.push({ path: '/home' })
    }
  }
}
</script>

<style lang="scss">
$phone-size: 600px;
$tablet-size: 960px;

.grid-buttons {
  display: grid;
  grid-template-columns: 35% 65%;
  grid-template-rows: auto auto;
  grid-template-areas:
    'first second'
    'third third';
  gap: 12px;
  max-width: 410px;
}

.first {
  grid-area: first;
}

.second {
  grid-area: second;
}

.third {
  grid-area: third;
}

.cursor-pointer {
  cursor: pointer;
}

.cliente-cadastrado {
  text-align: center;

  &-title {
    font-size: 20px;
    font-weight: 500;
    margin-bottom: 17px !important;
  }

  &-subtitle {
    font-size: 14px;
    color: #6b7580;
    max-width: 100%;
    margin: 0 auto 33px !important;
    max-width: 560px;
  }

  .link {
    margin: auto;
    font-size: 14px;
    color: #0079f2;
    cursor: pointer;
  }

  .link:hover {
    text-decoration: underline;
  }
}

@media screen and (max-width: $tablet-size) {
  .grid-buttons {
    grid-template-columns: 1fr;
    grid-template-rows: unset;
    grid-template-areas:
      'first'
      'second'
      'third';

    max-width: initial;
    & button {
      width: 100%;
    }
  }
}

@media screen and (min-width: $phone-size) {
  .cliente-cadastrado {
    text-align: left;

    &-title {
      font-size: 32px;
      margin-bottom: 8px !important;
    }

    &-subtitle {
      margin: 0 0 21px !important;
    }
  }
}
</style>
